import { Divider } from '@components'
import { Skeleton } from '@heroui/react'

const DashboardSkeleton = () => {
  return (
    Array(5).fill(null).map((e, i) => (

      <div key={i}>
        <div className="flex items-center" radius="lg">
          <div>
            <Skeleton className="flex w-12 h-12 rounded-full" />
          </div>

          <div className="w-full p-4 space-y-3">
            <Skeleton className="rounded-lg">
              <div className="h-5 rounded-lg bg-default-300"></div>
            </Skeleton>

            <Skeleton className="rounded-lg">
              <div className="h-3 rounded-lg bg-default-200"></div>
            </Skeleton>
          </div>
        </div>

        {(i !== 4) && <Divider className="my-3" />}
      </div>
    )))
}

export default DashboardSkeleton